import controller from './footer.controller';
import './footer.less';

export default {
  controller,
  template: require('./footer.html')
};



// WEBPACK FOOTER //
// src/app/components/footer/footer.component.ts